export const Config = {
    GetContent
}

function GetContent():string{
    return "/Content/GetContent";
}